import { FormControlBase } from '../models/form-control-base';
import { FormControlTypeEnum } from '../models/form-control-type.enum';

export class FormControlTextbox extends FormControlBase<string> {
	public controlType = FormControlTypeEnum.Textbox;
}
